var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"chatbot",attrs:{"href":"#"}},[_c('Icon',{attrs:{"name":"comment","size":"24","colorFont":"#02ACB4"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }